import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const companiesUrl = (path?: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'companies' },
    op: 'query',
    resourcePath: 'companies',
  };
  const base = buildBaseURL(opts);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
};

/**
 * GET /companies/:id/tas-approvers — returns a JSON:API document of
 * Employee records eligible to approve TAS for the company. Callers
 * should `store.push(response.content)` themselves to materialize the
 * employees (mirrors the legacy `pushPayload` + `push` calls inside the
 * old CompanyAdapter#getTasApprovers).
 */
export function getTasApproversRequest(companyId: string): RequestInfo {
  return {
    url: companiesUrl(`${companyId}/tas-approvers`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}

/** GET /companies/:id/eligibility-employee-counts — admin dashboard widget. */
export function getEligibilityCountsRequest(companyId: string): RequestInfo {
  return {
    url: companiesUrl(`${companyId}/eligibility-employee-counts`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}

/** GET /companies/:id/participation-employee-counts — admin dashboard widget. */
export function getParticipationCountsRequest(companyId: string): RequestInfo {
  return {
    url: companiesUrl(`${companyId}/participation-employee-counts`),
    method: 'GET',
    cacheOptions: { [SkipCache]: true },
  };
}
